// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingPlaceholderParent":"bee_a bik_wl","LoadingPlaceholder":"bee_b bik_h","loading-placeholder":"bee_c"};